import { render, staticRenderFns } from "./RsaPazientePrescrizioniEserciziComponent.vue?vue&type=template&id=25731944&scoped=true"
import script from "./RsaPazientePrescrizioniEserciziComponent.vue?vue&type=script&lang=js"
export * from "./RsaPazientePrescrizioniEserciziComponent.vue?vue&type=script&lang=js"
import style0 from "./RsaPazientePrescrizioniEserciziComponent.vue?vue&type=style&index=0&id=25731944&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25731944",
  null
  
)

export default component.exports